import { useContext } from 'react'

import { BankPortalContext } from './BankPortalContext'

export const useBankPortalContext = () => useContext(BankPortalContext)
